<template lang="pug">
transition(name="modal")
    .modal-mask2
      .modal-wrapper2( style="margin-left: auto; display: block; margin-right: auto;")
        .modal-container2          
          .modal-body2
            img(src="img/loader.gif",style="margin-left: auto; display: block; margin-right: auto; ")
</template>
<script>
export default{
  props : ['titulo','bindClass','tipo']
}
</script>
<style>   
    .modal-mask2 {
        position: absolute;
        z-index: 99999999999999999;
        background-color: rgba(0, 0, 0, .5);
        top: 0;
        left: 0;
        right: 0; 
        bottom: 0; 
        width: 100%;
        height: 100%; 
        transition: opacity .3s ease; 
        }
        .modal-wrapper2 {
         display: table-cell;
         vertical-align: middle;
         
        }

        .modal-container2 {
            
        margin: 0px auto;         
        padding: 0!important;
      
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;     
        }

        .modal-header2 h3 {
        margin-top: 0;
        color: #42b983;
        }
         .modal-header2{
           border-radius: 0!important;
         }
        .modal-body2 {
          
           margin: 5px 0; 
        }
      .modal-enter2 {
        opacity: 1;
      }

      .modal-leave-active {
        opacity: 0;
      }

    .modal-enter .modal-container2,
    .modal-leave-active .modal-container2 {
      -webkit-transform: scale(1.1);
      transform: scale(1.1);
    }

 
</style>